import { useBooleanFlagValue } from "@openfeature/react-sdk";
import { FeatureFlagVariables } from "../../../constants/featureFlag";

export function useIsAdminRedirectActive(): boolean {
  const defaultValue = false;

  const isAdminRedirectActive = useBooleanFlagValue(FeatureFlagVariables.isAdminRedirectActive, defaultValue);

  return isAdminRedirectActive;
}
